export default "__VITE_ASSET__QF53KtBL__"